<template>
  <!-- Deactive Modal -->
  <div class="modal custom-modal fade deactive-modal" id="deactive" role="dialog">
    <div class="modal-dialog modal-dialog-centered modal-md">
      <div class="modal-content">
        <div class="modal-header">
          <a class="close" data-bs-dismiss="modal" aria-label="Close">
            <span class="align-center" aria-hidden="true"><i class="feather-x"></i></span>
          </a>
        </div>
        <div class="modal-body">
          <!-- Deactive Account -->
          <div class="account-deactive">
            <img src="@/assets/img/icons/deactive-profile.svg" alt="Icon" />
            <h3>Are You Sure You Want to Deactive Account</h3>
            <p>If yes please click “Yes” button</p>
            <div class="convenient-btns">
              <a
                href="javascript:void(0);"
                data-bs-dismiss="modal"
                class="btn btn-primary d-inline-flex align-items-center"
              >
                Yes <span><i class="feather-arrow-right-circle ms-2"></i></span>
              </a>
              <a
                href="javascript:void(0);"
                data-bs-dismiss="modal"
                class="btn btn-secondary d-inline-flex align-items-center"
              >
                No <span><i class="feather-arrow-right-circle ms-2"></i></span>
              </a>
            </div>
          </div>
          <!-- /Deactive Account -->
        </div>
      </div>
    </div>
  </div>
  <!-- /Deactive Modal -->

  <!-- Email Success -->
  <div class="modal custom-modal fade deactive-modal" id="success-mail" role="dialog">
    <div class="modal-dialog modal-dialog-centered modal-md">
      <div class="modal-content">
        <div class="modal-header">
          <a class="close" data-bs-dismiss="modal" aria-label="Close">
            <span class="align-center" aria-hidden="true"><i class="feather-x"></i></span>
          </a>
        </div>
        <div class="modal-body">
          <!-- Deactive Account -->
          <div class="account-deactive">
            <img src="@/assets/img/icons/email-success.svg" alt="Icon" />
            <h3>Email Changed Successfully</h3>
            <p>Check your email on the confirmation</p>
            <div class="convenient-btns">
              <router-link
                to="/coaches/coach-dashboard"
                class="btn btn-primary d-inline-flex align-items-center me-0"
              >
                <span><i class="feather-arrow-left-circle me-2"></i></span>Back to
                Dashboard
              </router-link>
            </div>
          </div>
          <!-- /Deactive Account -->
        </div>
      </div>
    </div>
  </div>
  <!-- /Deactive Modal -->
</template>
